import { useState } from "react";
import Container from "react-bootstrap/Container";
import { SmartLink } from "../lib/navLink.jsx";

/**
 * Slim dismissible top bar — mirrors the AWS utility/announcement bar.
 * Props: message (string), linkLabel (string), linkHref (string),
 *        defaultVisible (bool, default true)
 */
export default function AnnouncementBar({
  message,
  linkLabel,
  linkHref,
  defaultVisible = true,
}) {
  const [visible, setVisible] = useState(defaultVisible);
  if (!visible || !message) return null;

  return (
    <div className="pmp-announcement-bar">
      <Container>
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="bi bi-megaphone-fill text-success" aria-hidden="true" />
            <span>{message}</span>
            {linkLabel && linkHref && (
              <SmartLink href={linkHref} className="ms-1">
                {linkLabel} &rarr;
              </SmartLink>
            )}
          </div>
          <button
            className="pmp-announcement-bar-dismiss"
            aria-label="Dismiss announcement"
            onClick={() => setVisible(false)}
          >
            <span className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </div>
      </Container>
    </div>
  );
}
